import { APP_NAME } from './brand';

/**
 * Profile badges, shown on the profile card next to the username. The CEO badge
 * comes from the staff rank; the others are given to accounts (by the CEO).
 */
export const BADGES = [
  { id: 'ceo', label: `${APP_NAME} CEO`, description: `Runs ${APP_NAME}.` },
  { id: 'alpha_tester', label: 'Alpha Tester', description: `Helped test ${APP_NAME} before launch.` },
  { id: 'founder', label: 'Founder', description: `Joined ${APP_NAME} before Blaze launched.` },
] as const;

export type BadgeId = (typeof BADGES)[number]['id'];

/** Badges that are given to accounts rather than coming from a rank. */
export const GRANTABLE_BADGES = ['alpha_tester', 'founder'] as const satisfies readonly BadgeId[];
export type GrantableBadgeId = (typeof GRANTABLE_BADGES)[number];

export function isGrantableBadge(id: string): id is GrantableBadgeId {
  return (GRANTABLE_BADGES as readonly string[]).includes(id);
}
